import { ScenarioWrapper, ScenarioScenario, ScenarioCriteria } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { ScenarioVO } from '../../vo/scenarii/scenario.vo';


/**
 * Commande REST de suppression des scenarii
 */
export class DeleteScenariiCommand extends WizCommand<ScenarioWrapper> {
  
  /**
   * le scenario porteur, pour refresh ciblé lors du retour
   */
  public targetScenario: ScenarioVO;
  /** les scenarii à supprimer */
  public scenarii: ScenarioVO[] = [];
  public visionCode: string;

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  public do(visionCode: string,targetScenario: ScenarioVO, scenarii: ScenarioVO[], callback: Function): DeleteScenariiCommand {
    this.targetScenario = targetScenario;
    this.scenarii = scenarii;
    this.visionCode = visionCode;

    let scenariiCodes: string[] = [];
    scenarii.forEach(scen => {
      scenariiCodes.push(scen.code);
    });

    const wrapper: ScenarioWrapper = new ScenarioWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.DELETE_LIST;
    wrapper.scenario = new ScenarioScenario();
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();
    wrapper.scenario.deleteLines = true;

    wrapper.criteria = new ScenarioCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.visionCode = visionCode;
    wrapper.criteria.scenariiCodes = scenariiCodes;

    this.configureRemote(ExternalAPI.SCENARIO_API, wrapper, callback);
    return this;
  }


  wizResult() {
    super.wizResult();
    this.model.scenarioEngine.removeScenarii(this.visionCode, this.scenarii);
  }

}
